<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ 'receipts.ui.totaliPerZona' | transloco }}</span>

  <button
    mat-icon-button
    type="button"
    [attr.aria-label]="'receipts.ui.chiudi' | transloco"
    class="close-button"
    (click)="close()"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="content">
  <div class="zone-totals">
    @for (item of data.totaliPerZona; track item.zona) {
      <div class="zone-total-row">
        <span class="body-medium">{{ item.zona }}</span>
        <span class="body-medium-emphasized">
          {{ item.totale | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
        </span>
      </div>
    }
  </div>

  <div class="total-divider"></div>

  <div class="grand-total-row">
    <span class="body-large-emphasized">{{ 'receipts.ui.totaleComplessivo' | transloco }}</span>
    <span class="body-large-emphasized">
      {{ data.totaleComplessivo | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="buttons-container">
  <button matButton="filled" type="button" (click)="close()">{{ 'receipts.ui.chiudi' | transloco }}</button>
</mat-dialog-actions>
